<template>
  <div class="game">
    <div
      class="game-board mask-animation"
      ref="gameBoard">
      <img
        class="fish"
        :style="{top: `${fish.y}px`, left: `${fish.x}px` }"
        :src="getItem('img/fish.svg')" />
      <!-- <div
        class="mask-overlay"
        ref="maskOverlay"
        :style="{
          backgroundImage: `url(${getItem('img/gameMask.svg')})`,
          backgroundPosition: `center center`,
          top: `${mask.y}px`,
          left: `${mask.x}px`
        }">
      </div>
      <div
        class="mask-overlay"
        ref="maskOverlay2"
        :style="{
          backgroundImage: `url(${getItem('img/gameMask.svg')})`,
          backgroundPosition: `center center`,
          top: `${mask.y}px`,
          left: `${mask.x}px`
        }">
      </div> -->

      <img
        class="mask-overlay"
        ref="maskOverlay"
        :src="getItem('img/gameMask.svg')"
        :style="{
          top: `${mask.y}px`,
          left: `${mask.x}px`
        }" />
      <img
        class="mask-overlay"
        ref="maskOverlay2"
        :src="getItem('img/gameMask.svg')"
        :style="{
          top: `${mask.y}px`,
          left: `${mask.x}px`
        }" />
      <game-timer :gameState="gameState" />
    </div>
    <div
      ref="clickLayer"
      class="clickLayer"
      @click="onClickBoard" />
    <transition name="fade">
      <div
        v-if="gameState === 'start'"
        class="game-content">
        <div class="game-text">Ergens in dit kader zit een visje. Tik op je scherm om 'm te vinden.</div>
        <button
          class="game-button"
          ref="startButton"
          @click="startGame()">start</button>
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="gameState === 'finished'"
        class="game-content">
        <div class="game-text">Gevonden!</div>
        <button
          class="game-button"
          ref="startButton"
          @click="restartGame()">begin opnieuw</button>
      </div>
    </transition>
  </div>

</template>
<script>

import GameTimer from './GameTimer'
import { trackGame } from '../utils/track.js'

export default {
  components: {
    GameTimer
  },
  mounted () {
    this.setBoundaries()
    this.setMaskOverlay(0, 0)
    this.setFishPosition()
  },
  props: {
    allowPlaying: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      gameState: 'start',
      timeouts: {
        mask1: null,
        mask2: null,
        animation: null
      },
      maskBasePosition: {
        x: -500,
        y: -550
      },
      // maskBasePosition: {
      //   x: -2500,
      //   y: -2750
      // },
      boundaries: {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 0
      },
      mask: {
        x: 0,
        y: 0
      },
      fish: {
        x: 0,
        y: 0,
        width: 50,
        height: 22
      }
    }
  },
  watch: {
    allowPlaying () {
      this.resetGame()
      this.resetTimeouts()
    }
  },
  methods: {
    changeState (state) {
      if (this.allowPlaying) {
        this.gameState = state
        trackGame(state)
      }
    },
    startGame () {
      this.setFishPosition()
      this.changeState('playing')
    },
    restartGame () {
      this.resetGame()
      trackGame('restart')
    },
    resetGame () {
      const mask = this.$refs.maskOverlay
      const mask2 = this.$refs.maskOverlay2

      this.resetTimeouts()
      mask.classList.remove('mask-pulse-animation')
      mask.classList.remove('mask-finished-animation')
      mask2.classList.remove('mask-pulse-animation-2')
      mask2.classList.remove('mask-finished-animation-2')

      this.mask.x = 0
      this.mask.y = 0
      this.setMaskOverlay(0, 0)

      this.changeState('start')
    },
    onClickBoard (event) {
      if (!this.gameState === 'playing') {
        return
      }
      const clickLayer = this.$refs.clickLayer
      const leftPosition = event.clientX - clickLayer.getBoundingClientRect().left
      const topPosition = event.clientY - clickLayer.getBoundingClientRect().top
      this.setMaskOverlay(leftPosition, topPosition)
      this.checkPosition(leftPosition - 25, topPosition - 11)
    },
    checkPosition (x, y) {
      if (
        x - 20 < this.fish.x &&
        x + 20 > this.fish.x &&
        y - 20 < this.fish.y &&
        y + 20 > this.fish.y) {
        this.changeState('finished')
        this.setMaskFinishedAnimation()
      } else {
        this.setMaskPulseAnimation()
        trackGame('missed')
      }
    },
    setBoundaries () {
      const board = this.$refs.gameBoard
      this.boundaries.x1 = 0
      this.boundaries.x2 = board.clientWidth
      this.boundaries.y1 = 0
      this.boundaries.y2 = board.clientHeight
    },
    setFishPosition () {
      this.fish.x = Math.random() * (this.boundaries.x2 - this.fish.width)
      this.fish.y = Math.random() * (this.boundaries.y2 - this.fish.height)
    },
    setMaskOverlay (x, y) {
      this.mask.x = this.maskBasePosition.x + x
      this.mask.y = this.maskBasePosition.y + y
    },
    setMaskFinishedAnimation () {
      const mask = this.$refs.maskOverlay
      const mask2 = this.$refs.maskOverlay2

      this.resetTimeouts()

      mask.classList.remove('mask-pulse-animation')
      this.timeouts.mask1 = setTimeout(() => {
        mask.classList.add('mask-finished-animation')
      }, 25)

      mask2.classList.remove('mask-pulse-animation-2')
      this.timeouts.mask2 = setTimeout(() => {
        mask2.classList.add('mask-finished-animation-2')
      }, 25)
    },
    setMaskPulseAnimation () {
      const mask = this.$refs.maskOverlay
      const mask2 = this.$refs.maskOverlay2

      this.resetTimeouts()

      mask.classList.remove('mask-pulse-animation')
      this.timeouts.mask1 = setTimeout(() => {
        mask.classList.add('mask-pulse-animation')
      }, 25)

      mask2.classList.remove('mask-pulse-animation-2')
      this.timeouts.mask2 = setTimeout(() => {
        mask2.classList.add('mask-pulse-animation-2')
      }, 25)

      this.timeouts.animation = setTimeout(() => {
        this.mask.x = this.maskBasePosition.x - 20
        this.mask.y = this.maskBasePosition.y - 20
      }, 525)
    },
    resetTimeouts () {
      clearTimeout(this.timeouts.mask1)
      clearTimeout(this.timeouts.mask2)
      clearTimeout(this.timeouts.animation)
    },
    getItem (src) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/${src}`)
    }
  }
}
</script>
<style lang="scss" scoped>
  .game {
    width: 100%;
    height: 500px;
    max-width: 450px;
    margin: 0 auto;
    position: relative;
    border-radius: 20px;
  }

  .game-content {
    display: flex;
    flex-flow: column nowrap;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 30px;
    justify-content: center;
    align-items: center;

    @include bigmobile {
      padding: 0 80px;
    }
  }

  .game-text {
    max-width: 300px;
    color: $nos-op3-red;
    text-align: center;
  }

  .game-button {
    margin-top: 25px;
    padding: 5px 20px;
    border: solid 1px $nos-op3-red;
    border-radius: 15px;
    background-color: transparent;
    color: $nos-op3-red;
    outline: none;
  }

  .game-board {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background-color: $nos-op3-light-blue;
    overflow: hidden;
  }

  .mask-overlay {
    // height: 5500px;
    // width: 5000px;
    height: 1100px;
    width: 1000px;
    position: absolute;
    top: calc(-500px + 50%);
    left: calc(-450px + 50%);
    transform: scale(1);
  }

  .fish {
    width: 50px;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
  }

  .clickLayer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border-radius: 20px;
    border: dashed 1px $nos-op3-red;
  }

  .mask-pulse-animation {
    transform: scale(1);
    animation: mask-animation-pulse 500ms;
    animation-fill-mode: forwards;
  }

  .mask-pulse-animation-2 {
    transform: scale(1);
    animation: mask-animation-pulse-2 500ms;
    animation-fill-mode: forwards;
  }

  .mask-finished-animation {
    transform: scale(1);
    animation: mask-animation-finished 500ms;
    animation-fill-mode: forwards;
  }

  .mask-finished-animation-2 {
    transform: scale(1);
    animation: mask-animation-finished-2 500ms;
    animation-fill-mode: forwards;
  }

  @keyframes mask-animation-pulse {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(7);
    }
  }

  @keyframes mask-animation-pulse-2 {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(7);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes mask-animation-finished {
    0% {
      opacity: 1;
     transform: scale(1);
    }
    100% {
      opacity: 1;
      transform: scale(7);
    }
  }

  @keyframes mask-animation-finished-2 {
    0% {
      opacity: 1;
     transform: scale(7);
    }
    50% {
      opacity: 1;
      transform: scale(7);
    }
    100% {
      opacity: 1;
      transform: scale(7);
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Game.vue